"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _lodash2 = _interopRequireDefault(require("lodash.find"));
var _lodash3 = _interopRequireDefault(require("lodash.isobject"));
var _styledComponents = require("styled-components");
var _reactPopper = require("react-popper");
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenDateTimeBase = _interopRequireDefault(require("@8x8/oxygen-date-time-base"));
var _predefinedRanges = _interopRequireDefault(require("../utils/predefinedRanges"));
var _constants = _interopRequireDefault(require("../utils/constants"));
var _DateTimeRangeSelectorDropdown = _interopRequireDefault(require("./DateTimeRangeSelectorDropdown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var registerEventHandlers = function registerEventHandlers(handlers) {
  if (!Array.isArray(handlers)) {
    return;
  }
  var _iterator = _createForOfIteratorHelper(handlers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var handler = _step.value;
      handler.target.addEventListener(handler.eventName, handler.callback, handler.capture);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var unregisterEventHandlers = function unregisterEventHandlers(handlers) {
  if (!Array.isArray(handlers)) {
    return;
  }
  var _iterator2 = _createForOfIteratorHelper(handlers),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var handler = _step2.value;
      handler.target.removeEventListener(handler.eventName, handler.callback, handler.capture);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
var hasValueSelected = function hasValueSelected(predefinedRange, dateTimeRange) {
  return predefinedRange.id !== _constants["default"] || (0, _lodash3["default"])(dateTimeRange);
};
var DateTimeRangeSelector = /*#__PURE__*/function (_PureComponent) {
  _inherits(DateTimeRangeSelector, _PureComponent);
  var _super = _createSuper(DateTimeRangeSelector);
  function DateTimeRangeSelector(props) {
    var _this;
    _classCallCheck(this, DateTimeRangeSelector);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onHideDropdown", function (_ref) {
      var target = _ref.target;
      if (_this.inputRef.current.contains(target) || _this.inputRef.current === target || _this.dropdownRef.current.contains(target) || _this.dropdownRef.current === target) {
        return;
      }
      _this.closeDropdown();
    });
    _defineProperty(_assertThisInitialized(_this), "getDateTimeRangeTitle", function () {
      var _this$props = _this.props,
        placeholder = _this$props.placeholder,
        predefinedRanges = _this$props.predefinedRanges,
        _this$props$predefine = _this$props.predefinedRange;
      _this$props$predefine = _this$props$predefine === void 0 ? {} : _this$props$predefine;
      var id = _this$props$predefine.id,
        value = _this$props$predefine.value,
        _this$props$dateTimeR = _this$props.dateTimeRange;
      _this$props$dateTimeR = _this$props$dateTimeR === void 0 ? {} : _this$props$dateTimeR;
      var startDate = _this$props$dateTimeR.startDate,
        endDate = _this$props$dateTimeR.endDate,
        dateFormat = _this$props.dateFormat,
        timeFormat = _this$props.timeFormat;
      var currentRange = (0, _lodash2["default"])(predefinedRanges, {
        id: id
      });
      if (currentRange) {
        var displayName = currentRange.displayName,
          selectedDisplayName = currentRange.selectedDisplayName;
        if (selectedDisplayName) {
          var displayValue = value || 'X';
          var _selectedDisplayName = _slicedToArray(selectedDisplayName, 2),
            firstLabel = _selectedDisplayName[0],
            secondLabel = _selectedDisplayName[1];
          return "".concat(firstLabel, " ").concat(displayValue, " ").concat(secondLabel);
        }
        if (displayName) {
          return displayName;
        }
      }
      if (startDate && endDate) {
        return "".concat((0, _format["default"])(startDate, "".concat(dateFormat, " ").concat(timeFormat)), " - ").concat((0, _format["default"])(endDate, "".concat(dateFormat, " ").concat(timeFormat)));
      }
      return placeholder || '';
    });
    _defineProperty(_assertThisInitialized(_this), "setDropdownRef", function (node) {
      _this.dropdownRef.current = node;
    });
    _defineProperty(_assertThisInitialized(_this), "setInputRef", function (node) {
      _this.inputRef.current = node;
    });
    _defineProperty(_assertThisInitialized(_this), "closeDropdown", function () {
      unregisterEventHandlers(_this.closeHandlers);
      _this.setState({
        isOpen: false
      }, _this.props.onClose);
    });
    _defineProperty(_assertThisInitialized(_this), "openDropdown", function () {
      registerEventHandlers(_this.closeHandlers);
      _this.setState({
        isOpen: true
      }, _this.props.onOpen);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDateRangeSelectorDropdown", function () {
      var isOpen = _this.state.isOpen;
      if (!isOpen) {
        _this.openDropdown();
      } else {
        _this.closeDropdown();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "addOnHideCallback", function (customCloseHandlers) {
      return customCloseHandlers.map(function (handler) {
        return _objectSpread(_objectSpread({}, handler), {}, {
          callback: _this.closeDropdown
        });
      });
    });
    _this.state = {
      isOpen: false
    };
    var _customCloseHandlers = _this.props.customCloseHandlers;
    _this.inputRef = /*#__PURE__*/_react["default"].createRef();
    _this.dropdownRef = /*#__PURE__*/_react["default"].createRef();
    _this.closeHandlers = [{
      target: document.body,
      eventName: 'click',
      callback: _this.onHideDropdown,
      capture: true
    }, {
      target: document.body,
      eventName: 'contextmenu',
      callback: _this.onHideDropdown,
      capture: true
    }].concat(_toConsumableArray(_this.addOnHideCallback(_customCloseHandlers)));
    return _this;
  }
  _createClass(DateTimeRangeSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        hasError = _this$props2.hasError,
        iconLeft = _this$props2.iconLeft,
        id = _this$props2.id,
        otherCalendarProps = _this$props2.otherCalendarProps,
        hidePredefinedRanges = _this$props2.hidePredefinedRanges,
        hideTime = _this$props2.hideTime,
        theme = _this$props2.theme,
        size = _this$props2.size,
        inputIcon = _this$props2.inputIcon,
        isDisabled = _this$props2.isDisabled,
        clearButtonLabel = _this$props2.clearButtonLabel,
        finishButtonLabel = _this$props2.finishButtonLabel,
        fromLabel = _this$props2.fromLabel,
        startTimeLabel = _this$props2.startTimeLabel,
        toLabel = _this$props2.toLabel,
        endTimeLabel = _this$props2.endTimeLabel,
        endTimeErrorMessage = _this$props2.endTimeErrorMessage,
        predefinedRanges = _this$props2.predefinedRanges,
        predefinedRange = _this$props2.predefinedRange,
        dateTimeRange = _this$props2.dateTimeRange,
        testId = _this$props2.testId,
        dateFormat = _this$props2.dateFormat,
        timeFormat = _this$props2.timeFormat,
        locale = _this$props2.locale,
        onRangeChange = _this$props2.onRangeChange,
        inputRenderer = _this$props2.inputRenderer,
        headerRenderer = _this$props2.headerRenderer,
        customPredefinedRangeLabel = _this$props2.customPredefinedRangeLabel;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(_reactPopper.Manager, null, /*#__PURE__*/_react["default"].createElement(_reactPopper.Reference, null, function (_ref2) {
        var ref = _ref2.ref;
        var inputProps = {
          hasError: hasError,
          id: id,
          isOpen: isOpen,
          isDisabled: isDisabled,
          size: size,
          testId: "".concat(testId, "_INPUT"),
          isValueSelected: hasValueSelected(predefinedRange, dateTimeRange),
          onClick: _this2.toggleDateRangeSelectorDropdown
        };
        if (inputRenderer) {
          inputProps.ref = ref;
          return inputRenderer(inputProps);
        }
        var dateTimeRangeTitle = _this2.getDateTimeRangeTitle();
        return /*#__PURE__*/_react["default"].createElement(_oxygenDateTimeBase["default"], _extends({}, inputProps, {
          iconLeft: iconLeft,
          inputIcon: inputIcon,
          theme: theme,
          popperAnchorRef: ref,
          setInputRef: _this2.setInputRef,
          title: dateTimeRangeTitle
        }));
      }), isOpen && /*#__PURE__*/_react["default"].createElement(_reactPopper.Popper, {
        placement: "bottom-start",
        positionFixed: true,
        innerRef: this.setDropdownRef
      }, function (_ref3) {
        var ref = _ref3.ref,
          style = _ref3.style;
        return /*#__PURE__*/_react["default"].createElement(_DateTimeRangeSelectorDropdown["default"], {
          headerRenderer: headerRenderer,
          otherCalendarProps: otherCalendarProps,
          hidePredefinedRanges: hidePredefinedRanges,
          hideTime: hideTime,
          theme: theme,
          testId: "".concat(testId, "_DROPDOWN"),
          onClose: _this2.closeDropdown,
          clearButtonLabel: clearButtonLabel,
          finishButtonLabel: finishButtonLabel,
          endTimeErrorMessage: endTimeErrorMessage,
          fromLabel: fromLabel,
          startTimeLabel: startTimeLabel,
          toLabel: toLabel,
          endTimeLabel: endTimeLabel,
          predefinedRanges: predefinedRanges,
          predefinedRange: predefinedRange,
          customPredefinedRangeLabel: customPredefinedRangeLabel,
          onRangeChange: onRangeChange,
          dateTimeRange: dateTimeRange,
          dateFormat: dateFormat,
          timeFormat: timeFormat,
          locale: locale,
          dropdownRef: ref,
          style: style
        });
      })));
    }
  }]);
  return DateTimeRangeSelector;
}(_react.PureComponent);
DateTimeRangeSelector.propTypes = {
  otherCalendarProps: _propTypes["default"].object,
  customCloseHandlers: _propTypes["default"].array,
  hasError: _propTypes["default"].bool,
  hidePredefinedRanges: _propTypes["default"].bool,
  hideTime: _propTypes["default"].bool,
  predefinedRanges: _propTypes["default"].array,
  predefinedRange: _propTypes["default"].object,
  dateTimeRange: _propTypes["default"].object,
  size: _propTypes["default"].oneOf(['large', 'small']),
  clearButtonLabel: _propTypes["default"].string,
  finishButtonLabel: _propTypes["default"].string,
  fromLabel: _propTypes["default"].string,
  startTimeLabel: _propTypes["default"].string,
  toLabel: _propTypes["default"].string,
  endTimeLabel: _propTypes["default"].string,
  customPredefinedRangeLabel: _propTypes["default"].string,
  endTimeErrorMessage: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  id: _propTypes["default"].string,
  testId: _propTypes["default"].string,
  dateFormat: _propTypes["default"].string,
  timeFormat: _propTypes["default"].string,
  inputIcon: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  iconLeft: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].elementType]),
  isDisabled: _propTypes["default"].bool,
  locale: _propTypes["default"].object,
  onRangeChange: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  theme: _propTypes["default"].object.isRequired,
  inputRenderer: _propTypes["default"].func,
  headerRenderer: _propTypes["default"].func
};
DateTimeRangeSelector.defaultProps = {
  otherCalendarProps: {},
  customCloseHandlers: [],
  hasError: false,
  hidePredefinedRanges: false,
  hideTime: false,
  predefinedRanges: _predefinedRanges["default"],
  predefinedRange: {
    id: _constants["default"]
  },
  dateTimeRange: undefined,
  size: 'large',
  clearButtonLabel: 'Clear',
  finishButtonLabel: 'Finish',
  fromLabel: 'From',
  startTimeLabel: 'Start Time',
  toLabel: 'To',
  endTimeLabel: 'End Time',
  customPredefinedRangeLabel: 'Custom',
  endTimeErrorMessage: 'Cannot be before start time',
  placeholder: 'Select Date Range',
  id: undefined,
  testId: 'DATE_TIME_RANGE_SELECTOR',
  dateFormat: 'MM/dd/yyyy',
  timeFormat: 'hh:mm a',
  inputIcon: undefined,
  iconLeft: null,
  isDisabled: false,
  locale: undefined,
  onRangeChange: _lodash["default"],
  onOpen: _lodash["default"],
  onClose: _lodash["default"],
  inputRenderer: undefined,
  headerRenderer: undefined
};
var _default = (0, _oxygenConfig.withTheme)(DateTimeRangeSelector, 'dateTimeRangeSelector');
exports["default"] = _default;